<template>
  <div class="edit-album-wrapper">
    <div class="edit-title flex">
      <el-button class="handlian-btn" @click="switchEdit">{{
        switchBtnText
      }}</el-button>
    </div>
    <div class="edit-body" v-show="showEditArea" v-loading="loadAlbum">
      <el-form
        :model="editAlbumForm"
        :rules="rules"
        :disabled="forbitEdit"
        ref="editAlbumForm"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item prop="albumTitle">
          <el-input
            v-model="editAlbumForm.albumTitle"
            placeholder="输入相册名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="albumContent">
          <el-input
            type="textarea"
            v-model="editAlbumForm.albumContent"
            resize="none"
            :autosize="{ minRows: 2 }"
            maxlength="300"
            show-word-limit
            placeholder="输入相册介绍"
          ></el-input>
        </el-form-item>
        <el-form-item class="original-item">
          <el-checkbox
            v-if="!reEditing"
            class="original-picture"
            v-model="originalPic"
            :disabled="forbitEdit"
            >原图上传</el-checkbox
          >
        </el-form-item>
        <el-form-item>
          <el-upload
            class="cl-upload-control"
            ref="upload"
            :limit="20"
            :multiple="true"
            accept="image/*"
            action="api/image/upload"
            :on-change="fileListChange"
            :before-upload="beforeUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-exceed="exceedLimit"
            list-type="picture-card"
            :auto-upload="false"
          >
            <i class="el-icon-plus" title="选择图片"></i>
            <div slot="tip" class="el-upload__tip">{{ uploaderTipText }}</div>
          </el-upload>
          <el-dialog :visible.sync="previewVisible">
            <img width="100%" :src="previewImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <div class="edit-bar">
            <el-button
              class="handlian-btn"
              :disabled="forbitEdit"
              type="primary"
              @click="submitForm('editAlbumForm')"
              >{{ saveBtnText }}</el-button
            >
            <el-button
              class="handlian-btn"
              :disabled="resetForbit"
              @click="resetForm('editAlbumForm')"
              >重置</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="shareVisible"
      width="30%"
      custom-class="handlian-share-article"
      :before-close="clearShareForm"
    >
      <span class="share-tip"
        >上传成功，您还可以分享新相册，不分享就点“取消”。</span
      >
      <el-form
        :model="shareAlbumForm"
        :rules="shareRules"
        ref="shareAlbumForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="分享区域" prop="shareArea">
          <el-checkbox-group v-model="shareAlbumForm.shareArea">
            <el-checkbox label="shareFriends" name="shareArea"
              >小区</el-checkbox
            >
            <el-checkbox label="sharePublic" name="shareArea">社区</el-checkbox>
            <el-checkbox label="shareFamily" name="shareArea">族窗</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="handlian-btn" @click="clearShareForm"
          >取 消</el-button
        >
        <el-button
          class="handlian-btn"
          type="primary"
          @click="submitShareForm('shareAlbumForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { apiMap } from "../../utils/apiMap";
import { newFileName, htmlFilter } from "../../utils/feed";
import { mapGetters } from "vuex";
import Compressor from "compressorjs";
import qs from "qs";
let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
export default {
  name: "album-edit",
  data() {
    return {
      showEditArea: false,
      switchBtnText: "创建相册",
      saveBtnText: "上传相册",
      reEditing: false,
      resetForbit: false,
      previewVisible: false,
      shareVisible: false,
      loadAlbum: false,
      onInitImage: true,
      originalPic: false,
      newAlbumID: "",
      oldAlbumID: "",
      previewImageUrl: "",
      editAlbumForm: {
        albumTitle: "",
        albumContent: "",
      },
      uploaderTipText: "单次可上传 20 张图片",
      shareAlbumForm: {
        shareArea: [],
      },
      rules: {
        albumTitle: [
          { required: true, message: "请输入相册名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        albumContent: [
          { required: false, message: "请输入相册介绍", trigger: "blur" },
        ],
      },
      shareRules: {
        shareArea: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个分享区域",
            trigger: "change",
          },
        ],
      },
      fileList: [],
      imageList: [],
      successFiles: [],
      failFiles: [],
      articleTags: [],
      doneFile: [],
      fileCount: 0,
      forbitUpload: false,
      forbitEdit: false,
      forbitSave: false,
    };
  },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  mounted() {
    this.$bus.$on("edit-album", this.initEditAlbum);
  },
  methods: {
    switchEdit() {
      if (this.showEditArea == false) {
        this.showEditArea = true;
        this.switchBtnText = "取消创建";
        this.initUserPermission();
      } else {
        this.showEditArea = false;
        this.switchBtnText = "创建相册";
        this.resetForm("editAlbumForm");
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      // 删除本地
      this.imageList = fileList;
      this.uploaderTipText = `单次可上传 20 张图片 已选${fileList.length}张`;
    },
    handlePreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    exceedLimit(file, fileList) {
      this.$message({
        message: "最多可选择20张图片哦",
        duration: 1500,
        offset: 230,
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
      this.forbitSave = false;
      this.forbitUpload = false;
      this.forbitEdit = false;
      this.reEditing = false;
      this.onInitImage = true;
      this.originalPic = false;
      this.doneFile = [];
      this.fileList = [];
      this.imageList = [];
      this.successFiles = [];
      this.failFiles = [];
      this.fileCount = 0;
      this.oldAlbumID = "";
      if (this.showEditArea) {
        this.switchBtnText = "取消创建";
      } else {
        this.switchBtnText = "创建相册";
      }
      this.saveBtnText = "上传相册";
      this.uploaderTipText = "单次可上传 20 张图片";
    },
    resetEditor() {
      this.resetForm("editAlbumForm");
    },
    fileListChange(file, fileList) {
      console.log(file);
      // console.log(fileList)
      let img_regexp = /^image\/\w/g;
      if (!img_regexp.test(file.raw.type)) {
        this.$message({
          message: "请选择图片文件",
          duration: 1500,
          offset: 230,
        });
        return false;
      }
      this.imageList = fileList;
      this.uploaderTipText = `单次可上传 20 张图片 已选${fileList.length}张`;
      // let findImage = this.imageList.filter(item=>item.name==file.name);
      // if (findImage.length==0) {
      //     this.imageList.push(file)
      // }
    },
    beforeUpload(file) {
      console.log(file);
      var newFile = new File([file], newFileName(file.name));
      var formData = new FormData();
      formData.append("file", newFile);
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["uploadUrl"],
          method: apiMap["uploadFile"]["method"],
          url: apiMap["uploadFile"]["url"],
          data: formData,
          timeout: 6000,
        })
        .then(function(response) {
          if (response.data.code == 200) {
            $this.successFiles.push(newFile);
            let curFile = {
              name: response.data.fileName,
              url: response.data.file,
              size: newFile.size,
            };
            $this.doneFile.push(curFile);
          } else {
            $this.failFiles.push(newFile);
          }

          var myInterval = setInterval(function() {
            let successFiles = $this.successFiles;
            let failFiles = $this.failFiles;
            if (successFiles.length + failFiles.length == $this.fileCount) {
              clearInterval(myInterval);
              if ($this.onInitImage) {
                $this.initAlbumImage();
              }
            }
          }, 1000);
        })
        .catch(function(error) {
          console.log(error);
          if (error.message.includes("timeout")) {
            $this.$alert("文件上传超时", {
              confirmButtonText: "确定",
              showClose: false,
            });
          } else {
            $this.$message({
              message: "文件上传出错",
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
          $this.initAlbumImage();
        });
      return false;
    },
    initAlbumImage() {
      let uploadFiles = this.doneFile;
      console.log(uploadFiles);
      var tempKey = [];
      var tempSize = 0;
      for (let index = 0; index < uploadFiles.length; index++) {
        tempKey.push(uploadFiles[index].url);
        tempSize += uploadFiles[index].size;
      }
      if (tempKey.length != 0 && tempSize != 0) {
        this.onInitImage = false;
        tempSize = (tempSize / 1024).toFixed(2);
        this.publishAlbum(
          this.$refs["editAlbumForm"].model,
          tempKey.join(","),
          tempSize
        );
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.$refs[formName].model);
          if (this.reEditing) {
            this.saveOldAlbum(this.$refs[formName].model);
          } else {
            let awaitFiles = this.imageList;
            if (this.imageList.length != 0) {
              this.fileCount = this.imageList.length;
              if (this.originalPic) {
                this.inOrderUpload(0);
              } else {
                this.afterReadCompress(0);
              }
              //this.submitUpload();
            } else {
              this.$message({
                message: "请选择照片",
                type: "warning",
                duration: 1500,
                offset: 230,
              });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    afterReadCompress(index) {
      let _this = this;
      let currentFile = _this.imageList[index];
      if (currentFile && currentFile.raw) {
        var file = currentFile.raw;
        new Compressor(file, {
          quality: 0.6,
          success(result) {
            var newFile = new File([result], newFileName(result.name));
            var formData = new FormData();
            formData.append("file", newFile);
            _this
              .$axios({
                baseURL: apiMap["uploadUrl"],
                method: apiMap["uploadFile"]["method"],
                url: apiMap["uploadFile"]["url"],
                data: formData,
                timeout: 6000,
              })
              .then(function(response) {
                if (response.data.code == 200) {
                  currentFile.status = "success";
                  _this.successFiles.push(newFile);
                  let curFile = {
                    name: response.data.fileName,
                    url: response.data.file,
                    size: newFile.size,
                  };
                  _this.doneFile.push(curFile);
                } else {
                  currentFile.status = "failed";
                  _this.failFiles.push(newFile);
                }

                if (index < _this.imageList.length) {
                  index++;
                  _this.afterReadCompress(index);
                }

                if (
                  _this.successFiles.length + _this.failFiles.length ==
                  _this.fileCount
                ) {
                  _this.initAlbumImage();
                }
              })
              .catch(function(error) {
                console.log(error);
                if (error.message.includes("timeout")) {
                  _this.$dialogue
                    .alert({
                      message: "文件上传超时",
                      confirmButtonColor: "#1a70db",
                    })
                    .then(() => {});
                } else {
                  _this.$message({
                    message: "文件上传出错",
                    type: "warning",
                    offset: 50,
                  });
                }
                _this.initAlbumImage();
              });
          },
          error(err) {
            _this.fileCount -= 1;
            console.log(err.message);
          },
        });
      }
    },
    inOrderUpload(index) {
      let _this = this;
      let currentFile = _this.imageList[index];
      if (currentFile && currentFile.raw) {
        var file = currentFile.raw;
        var newFile = new File([file], newFileName(file.name));
        var formData = new FormData();
        formData.append("file", newFile);
        _this
          .$axios({
            baseURL: apiMap["uploadUrl"],
            method: apiMap["uploadFile"]["method"],
            url: apiMap["uploadFile"]["url"],
            data: formData,
            timeout: 6000,
          })
          .then(function(response) {
            if (response.data.code == 200) {
              _this.successFiles.push(newFile);
              let curFile = {
                name: response.data.fileName,
                url: response.data.file,
                size: newFile.size,
              };
              _this.doneFile.push(curFile);
            } else {
              _this.failFiles.push(newFile);
            }

            if (index < _this.imageList.length) {
              index++;
              _this.inOrderUpload(index);
            }

            if (
              _this.successFiles.length + _this.failFiles.length ==
              _this.fileCount
            ) {
              _this.initAlbumImage();
            }
          })
          .catch(function(error) {
            console.log(error);
            if (error.message.includes("timeout")) {
              _this.$alert("文件上传超时", {
                confirmButtonText: "确定",
                showClose: false,
              });
            } else {
              _this.$message({
                message: "文件上传出错",
                type: "warning",
                duration: 1500,
                offset: 230,
              });
            }
            _this.initAlbumImage();
          });
      }
    },
    submitUpload() {
      this.forbitUpload = true;
      this.$refs.upload.submit(); // 自动执行beforeUpload()
    },
    publishAlbum(formData, picture, fileSize) {
      let _this = this;
      _this.forbitEdit = true;
      var params = {
        token: loginUser.token,
        title: formData.albumTitle,
        introduction: encodeURIComponent(formData.albumContent),
        image: picture,
        storage: fileSize,
      };
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["uploadAlbum"]["method"],
          url: apiMap["uploadAlbum"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.showEditArea = false;
            _this.switchBtnText = "创建相册";
            _this.resetForm("editAlbumForm");
            _this.newAlbumID = response.data.result.data;
            _this.shareVisible = true;
            _this.$bus.$emit("reload-album-list");
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
            _this.$refs.upload.clearFiles();
            _this.fileCount = 0;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveOldAlbum(formData) {
      let _this = this;
      if (_this.oldAlbumID == "") {
        return false;
      }
      _this.forbitEdit = true;
      let paramArr = [
        `token=${loginUser.token}`,
        `title=${formData.albumTitle}`,
        `introduction=${encodeURIComponent(formData.albumContent)}`,
        `photoId=${_this.oldAlbumID}`,
      ];
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["updateAlbum"]["method"],
          url: apiMap["updateAlbum"]["url"],
          data: paramArr.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.showEditArea = false;
            _this.resetForm("editAlbumForm");
            _this.$message({
              message: "编辑成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.$bus.$emit("reload-album-list");
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    clearShareForm() {
      this.$refs["shareAlbumForm"].resetFields();
      this.shareVisible = false;
    },
    submitShareForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(_this.$refs[formName].model);
          let shareArea = _this.$refs[formName].model.shareArea;
          if (shareArea.length == 1) {
            _this.shareNewAlbum(shareArea[0]);
          } else if (shareArea.length > 0) {
            for (let index = 0; index < shareArea.length; index++) {
              const element = shareArea[index];
              _this.shareNewAlbum(element);
            }
          }
          _this.$alert("审核通过后立即发布", "内容审核中", {
            confirmButtonText: "知道了",
            callback: (action) => {},
          });
          _this.clearShareForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    shareNewAlbum(shareArea) {
      let _this = this;
      if (_this.newAlbumID == "") {
        return false;
      }
      let params = `token=${loginUser.token}&photoId=${_this.newAlbumID}&shareField=${shareArea}&shareValue=1`;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["albumShare"]["method"],
          url: apiMap["albumShare"]["url"],
          data: params,
        })
        .then(function(response) {
          // let tips = "";
          // switch (shareArea) {
          //   case "shareFriends":
          //     tips = "到小区";
          //     break;
          //   case "sharePublic":
          //     tips = "到社区";
          //     break;
          // }
          if (response.data.result.statusCode == 1) {
            // let msg = `分享${tips}成功！`;
            // _this.$message({
            //   message: msg,
            //   type: "success",
            //   duration: 1500,
            //   offset: 230,
            // });
            _this.$bus.$emit("reload-album-list");
          } else {
            // let msg = `分享${tips}失败，稍后再试`;
            // _this.$message({
            //   message: msg,
            //   type: "warning",
            //   duration: 1500,
            //   offset: 230,
            // });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initUserPermission() {
      // console.log(this.userProfile)
      if (this.userProfile.photoPermission == 0) {
        this.$alert("抱歉，您目前没有权限上传相册", {
          confirmButtonText: "确定",
          showClose: false,
        });
        this.forbitEdit = true;
      } else {
        var myTempSpace = parseFloat(
          this.userProfile["tempSpaceSizeMbNum"]
        ).toFixed(2);
        var residueSpace = myTempSpace - this.userProfile["tempUsedSpaceMBNum"];
        if (residueSpace < 0) {
          this.$alert("您的短期空间不足，请在手机端续费或购买", {
            confirmButtonText: "确定",
            showClose: false,
          });
          this.forbitEdit = true;
        }
      }
    },
    initEditAlbum(albumID) {
      this.showEditArea = true;
      this.switchBtnText = "取消编辑";
      this.uploaderTipText = "重新编辑相册时，不能选择图片";
      this.saveBtnText = "保存";
      this.forbitUpload = true;
      this.loadAlbum = true;
      document.documentElement.scrollTop = 0;
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            token: loginUser.token,
            modelId: albumID,
            modelType: 2,
            self: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.loadAlbum = false;
            _this.reEditing = true;
            _this.oldAlbumID = response.data.result.data.modelId;
            _this.editAlbumForm.albumTitle = htmlFilter(
              response.data.result.data.title
            );
            if (response.data.result.data.introduction != "null") {
              _this.editAlbumForm.albumContent = htmlFilter(
                response.data.result.data.introduction
              );
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.edit-body {
  min-height: 80px;
  margin: 15px 0 0;
}

.original-item {
  margin-bottom: 8px;
  margin-top: -15px;
}
</style>
